import { JSONRPCServer } from 'json-rpc-2.0';

export async function apiCall(url, method, body = null) {
  const token = document.querySelector('meta[name="csrf-token"]')?.content;

  const response = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': token
    },
    body: body ? JSON.stringify(body) : null
  });

  if (!response.ok) throw await response.json();
  return await response.json();
}

// Create JSON-RPC server and register methods
const server = new JSONRPCServer();

server.addMethod('formcut.configurator.v1.configureItem', async (params) => {
  const iframe = document.getElementById('configurator');
  let lineItemId = null;
  let isClone = false;

  if (iframe && iframe.dataset.configuratorInitParams) {
    try {
      const initParams = JSON.parse(iframe.dataset.configuratorInitParams);
      lineItemId = initParams.lineItemId;
      isClone = initParams.isClone || false;
    } catch (e) {
      console.error('Failed to parse configurator init params:', e);
    }
  }

  if (lineItemId && !isClone) {
    // Update existing line item (only if not a clone)
    const updateData = {
      ...params.configuredItem,
      quantity: params.quantity
    };

    await apiCall(
      `/line_items/${lineItemId}`,
      'PUT',
      updateData
    );
  } else {
    // Create new configured item and line item (for new items or clones)
    const configuredItemRes = await apiCall(
      `/configured_items`,
      'POST',
      params.configuredItem
    );

    const configuredItemId = configuredItemRes?.configured_item?.id;
    const queryString = `configured_item_id=${configuredItemId}&quantity=${params.quantity}`;

    await apiCall(`/line_items?${queryString}`, 'POST');
  }

  window.location.href = '/basket';
  return { success: true };
});

server.addMethod('formcut.configurator.v1.getData', async () => {
  const iframe = document.getElementById('configurator');
  if (!iframe) {
    throw new Error('Configurator iframe not found');
  }

  const propsJSON = iframe.dataset.configuratorInitParams;
  if (!propsJSON) {
    throw new Error('Configurator init params not available');
  }

  try {
    return JSON.parse(propsJSON);
  } catch (error) {
    throw new Error('Failed to parse configurator init params');
  }
});

window.addEventListener('message', async function (event) {
  const allowedOrigin = window.CONFIGURATOR_URL;
  const allowedOriginOnly = new URL(allowedOrigin).origin;

  if (event.origin !== allowedOriginOnly) {
    console.warn('Blocked because of the unknown source:', event.origin);
    return;
  }

  if (!event.data.jsonrpc) return;  // Ignore non-JSON-RPC messages

  try {
    const response = await server.receive(event.data);
    if (response) {
      // Send response back to iframe
      event.source.postMessage(response, event.origin);
    }
  } catch (error) {
    console.error('JSON-RPC processing error:', error);
  }
});
